// @flow
import type { Dispatch } from "redux"
import JsCookie from "js-cookie"

import cuckoo from "../cuckoo/cuckoo"
import { openModal } from "../../../booking/services/modals/actions"
import translate from "../../../../app/scripts/tools/translate"
import { cuckooEvents } from "../../consts/enums"
import isReservationPristine from "../../../booking/services/reservation/tools/isReservationPristine"
import saveReservationFormAction from "../../../booking/services/reservation/actions/saveReservationFormAction"
import { RESERVATION_MODALS } from "../../../booking/scenes/Modals/consts/modalsConsts"

// main config for showing whole abandonment
const ENABLE_ABANDONMENT = false

// JSCookie accepts duration in day units -> converted to 8 hours
const ABANDONMENT_EXPIRATION_TIME = 1 / 3
const ABANDONMENT_COOKIE_NAME = "abandonment_modal_visited"

const ENABLED_AFFILIATES = ["skyscanner", "kayak"]

let nativeCloseHandler = null
let expectedCloseHandler = null

export function isRecentlyVisited() {
  return Boolean(JsCookie.get(ABANDONMENT_COOKIE_NAME))
}

// eslint-disable-next-line consistent-return
export function showAbandonmentModal(dispatch: Dispatch<any>) {
  cuckoo.track(cuckooEvents.BOOKING_ABANDONMENT_MODAL_SHOWN)
  cuckoo.infinario("abandonmentModal", { status: "opened" })

  dispatch(openModal(RESERVATION_MODALS.ABANDONMENT))
}

// Save to cookies to avoid showing abandonment multiple times
export function saveVisiting() {
  JsCookie.set(ABANDONMENT_COOKIE_NAME, true, {
    ...window.Skypicker.cookieOptions,
    expires: ABANDONMENT_EXPIRATION_TIME,
  })
}

// Show message on browser close
// http://stackoverflow.com/a/21455923/1732483
function bindNativeClose(dispatch: Dispatch<any>) {
  // For >=IE7, Chrome, Firefox
  // eslint-disable-next-line consistent-return
  nativeCloseHandler = ev => {
    if (JsCookie.get("deactivate_window_close_handler")) return undefined

    // Store unfinished booking data
    dispatch(saveReservationFormAction())

    if (!dispatch(isReservationPristine())) {
      const confirmationMessage = translate("booking.global.question_leave_booking")
      const receiver = ev || window.event
      receiver.returnValue = confirmationMessage
      return confirmationMessage
    }
  }

  if (!JsCookie.get("deactivate_window_close_handler")) {
    window.addEventListener("beforeunload", nativeCloseHandler)
  }
}

function unbindNativeClose() {
  if (nativeCloseHandler) {
    window.removeEventListener("beforeunload", nativeCloseHandler)
  }
}

// For now show abandonment modal only for part of skyscanner || kayak affiliate traffic
function isOneOfEnabledAffiliates(activeAffiliate) {
  return activeAffiliate
    ? ENABLED_AFFILIATES.filter(x => activeAffiliate.includes(x)).length
    : false
}

function bindExpectedLeave(dispatch: Dispatch<any>) {
  // Trigger only when cursor moved to close tab button
  expectedCloseHandler = (ev: MouseEvent) => {
    if (ev.clientY < 0 && !isRecentlyVisited()) {
      saveVisiting()
      showAbandonmentModal(dispatch)
    }
  }

  if (document.body && ENABLE_ABANDONMENT) {
    document.body.addEventListener("mouseleave", expectedCloseHandler)
  }
}

function unbindExpectedLeave() {
  if (document.body && expectedCloseHandler) {
    document.body.removeEventListener("mouseleave", expectedCloseHandler)
  }
}

export function init(dispatch: Dispatch<any>, affiliate: string, containsTrain: boolean) {
  bindNativeClose(dispatch)

  // AB test feedback abandonment modal
  if (isOneOfEnabledAffiliates(affiliate) || containsTrain) {
    bindExpectedLeave(dispatch)
  }
}

export function cancel() {
  unbindNativeClose()
  unbindExpectedLeave()
}
